export const deClientPortalOrderSidebarPages = {
    orders: {
        orderSidebar: {
            overview: 'Übersicht',
        },
    },
}
